import { v4 as uuidv4 } from 'uuid';
import {
  TLS_ONLINE_CLIENT_ID,
} from '../constants/travelerDataConstants';

export const makeFetch = async ({
  url,
  body,
  method,
  headers,
}) => {
  const correlationId = uuidv4();
  const response = await fetch(url, {
    method,
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      clientId: TLS_ONLINE_CLIENT_ID,
      correlationId,
      ...headers,
    },
    body: JSON.stringify(body),
  });

  return {
    response,
    correlationId,
  };
};

export const makePost = async ({
  url,
  body,
  headers,
}) => makeFetch({
  url,
  body,
  method: 'POST',
  headers,
});

export const makePut = async ({
  url,
  body,
  headers,
}) => makeFetch({
  url,
  body,
  method: 'PUT',
  headers,
});
